import { useSnackbar } from 'notistack';
import { useState, useEffect } from 'react';
import { training } from 'src/backend';
import useAuth from 'src/hooks/useAuth';

export default function useTrainingSettings() {
  const { enqueueSnackbar } = useSnackbar();
  const [settings, setSettings] = useState();
  const { user } = useAuth();

  useEffect(() => {
    if (user.account_type !== 'ADMIN') {
      if (settings) return;

      training
        .getSettings()
        .then(setSettings)
        .catch(() =>
          enqueueSnackbar(
            'There was an error fetching the training program settings.',
            { variant: 'error' }
          )
        );
    }
  }, [settings, setSettings, enqueueSnackbar]);

  const updateSettings = (updates) => {
    setSettings({ ...settings, ...updates });
    training.updateSettings({ ...settings, ...updates });
  };

  return {
    isLoading: !settings,
    settings: settings ?? {},
    setSettings: updateSettings,
  };
}
